//Importaciones
import React, { useContext, useState } from 'react';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { useTranslation } from 'react-i18next';
import { ActionButton, Coachmark, IconButton } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import MainAppContext from '../../../MainAppContext';
import PropTypes from 'prop-types';

import './style.css'

import { getNextTechStepBoardConfig, getNextTechStepBulkUpload, getNextTechStepGapPage } from '../../../common/Helpers';

export const TeachBubbleMultiSteps = (props) => {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const { 
        inputParam_ButtonId = null,
        inputParam_IsHTML = false,
        inputParam_Title = "",
        inputParam_IconProps = { iconName: 'UnknownSolid' },
        inputParam_ButtonStyles = { icon: { fontSize: "25px" }, root: {height: "30px" } },
        inputParam_ButtonText = null,
        inputParam_ClassName = "",
        inputParam_ButtonClassName = "pb-3",
        inputParam_DirectionalHint = DirectionalHint.bottomCenter,
        inputParam_Steps = [],
        inputParam_NextTechStepType = null
    } = props;

    //Parametros de componente.
    const [teachBubbSelectElementTypeVisible, { toggle: toggleTeachBubbSelectElementTypeVisible }] = useBoolean(false);
    const [currentStep, setCurrentStep] = useState(0);

    const [isCoachmarkVisible, setIsCoachmarkVisible] = useState(false);

    const nextStep = () => {
        if (currentStep < inputParam_Steps.length - 1) {
            if (!isCoachmarkVisible) {
                setIsCoachmarkVisible(true)
            }
            setCurrentStep(currentStep + 1);
            onChangeCurrentTeachStep(currentStep + 1);
        }
      };
    
    const prevStep = () => {
        if (currentStep > 0) {
            if (!isCoachmarkVisible) {
                setIsCoachmarkVisible(true)
            }
            setCurrentStep(currentStep - 1);
            onChangeCurrentTeachStep(currentStep - 1);
        }
    };

    const onOpen = () => {
        toggleTeachBubbSelectElementTypeVisible();
        setIsCoachmarkVisible(true)
    }

    const onClose = () => {
        setCurrentStep(0);
        toggleTeachBubbSelectElementTypeVisible();
        setIsCoachmarkVisible(false)
    }

    const onChangeCurrentTeachStep = (value) => {
        setCurrentStep(value)
        setIsCoachmarkVisible(true)
    }

    const calculateCoachmarkTargetButton = (_currentStep) => {
        if (inputParam_NextTechStepType === "BoardConfig") {
            return getNextTechStepBoardConfig(_currentStep)
        }
        else if (inputParam_NextTechStepType === "BulkUpload") {
            return getNextTechStepBulkUpload(_currentStep)
        }
        else if (inputParam_NextTechStepType === "GapPage") {
            return getNextTechStepGapPage(_currentStep)
        }
    }

    //Render de componente.
    return (
        <div className={inputParam_ClassName}>
            {
                ((inputParam_ButtonText !== null && inputParam_ButtonText !== undefined) || contextSite.help.value) && (
                <>
                    {
                       (inputParam_ButtonText !== null && inputParam_ButtonText !== undefined) &&
                       <ActionButton id={inputParam_ButtonId} styles={ inputParam_ButtonStyles } className={inputParam_ButtonClassName} onClick={ onOpen } iconProps={inputParam_IconProps} allowDisabledFocus >{inputParam_ButtonText}</ActionButton>
                    }
                    {
                        (inputParam_ButtonText === null || inputParam_ButtonText === undefined) &&
                       <IconButton id={inputParam_ButtonId} styles={ inputParam_ButtonStyles } className={inputParam_ButtonClassName} iconProps={inputParam_IconProps} onClick={ onOpen } />
                    }
                    {
                        teachBubbSelectElementTypeVisible &&
                        
                        <TeachingBubble
                            hasSmallHeadline={true}
                            calloutProps={ { directionalHint: inputParam_DirectionalHint } }
                            styles={
                                (inputParam_ButtonText !== null && inputParam_ButtonText !== undefined) ?
                                {
                                    closeButton: {
                                        color: 'black',
                                            selectors: {
                                            ':hover': {
                                                background: 'gainsboro',
                                                color: 'black'
                                            },
                                            ':active': {
                                                background: 'darkGray',
                                                color: 'black'
                                            }
                                        }
                                    },
                                    content: {
                                        border: '1px solid black',
                                        background: 'white',
                                        color: 'black !important'
                                    },
                                    bodyContent: {
                                        color: 'black !important'
                                    },
                                    headline: {
                                        color: 'black'
                                    },
                                    subText: {
                                        color: 'black !important'
                                    },
                                    subComponentStyles: {
                                        callout: {
                                            beak: [
                                                {
                                                    background: "white",
                                                    borderLeft: "1px solid transparent",
                                                    borderTop: "1px solid transparent",
                                                    zIndex: 9,
                                                    boxShadow: "none",
                                                },
                                            ],
                                            calloutMain: [
                                                {
                                                    background: "white",
                                                },
                                            ],
                                        },
                                    },
                                }
                                    :
                                {
                                    content: {
                                        border: '1px solid black',
                                        color: 'white !important'
                                    },
                                    bodyContent: {
                                        color: 'white !important'
                                    },
                                    headline: {
                                        color: 'white !important'
                                    },
                                    subText: {
                                        color: 'white !important'
                                    },
                                    subComponentStyles: {
                                        callout: {
                                            beak: [
                                                {
                                                    borderLeft: "1px solid transparent",
                                                    borderTop: "1px solid transparent",
                                                    zIndex: 9,
                                                    boxShadow: "none",
                                                },
                                            ],
                                        },
                                    },
                                }
                            }
                            target={ `#${inputParam_ButtonId}` }
                            isWide={ true }
                            hasCloseButton={ true }
                            closeButtonAriaLabel={ t('data-lang-lbl-close') }
                            onDismiss={ onClose }
                            headline={ inputParam_Title }
                            secondaryButtonProps={
                                { 
                                    disabled: (currentStep + 1 !== inputParam_Steps.length ? false : true) , 
                                    text: t('data-lang-lbl-next'), 
                                    onClick: nextStep, className: 'stepButton' 
                                }
                            }
                            primaryButtonProps={
                                {
                                    disabled: (currentStep !== 0 ? false : true), 
                                    text: t('data-lang-lbl-prev'), 
                                    onClick: prevStep, className: 'stepButton' 
                                }
                            }
                        >
                            { inputParam_Steps[currentStep] }
                        </TeachingBubble>
                    }
                    {
                        isCoachmarkVisible &&
                        <Coachmark
                            target={calculateCoachmarkTargetButton(currentStep)}
                            positioningContainerProps={{
                                directionalHint: DirectionalHint.bottomCenter,
                            }}
                            preventFocusOnMount={true}
                        />
                    }
                </>)
            }
        </div>
    );
};

///Proptypes
TeachBubbleMultiSteps.propTypes = {
    inputParam_ButtonId: PropTypes.string.isRequired,
    inputParam_Title: PropTypes.string.isRequired,
    inputParam_IconProps: PropTypes.object,
    inputParam_ButtonStyles: PropTypes.object,
    inputParam_ButtonText: PropTypes.string,
    inputParam_ButtonEvent: PropTypes.func,
    inputParam_ButtonEventParams: PropTypes.object,
    inputParam_IsHTML: PropTypes.bool,
    inputParam_ClassName: PropTypes.string,
    inputParam_ButtonClassName: PropTypes.string,
    inputParam_DirectionalHint: PropTypes.number,
};